import FieldText from "@/components/fields/FieldText";
import FieldTextBlock from "@/components/fields/FieldTextBlock";
import FieldPhone from "@/components/fields/FieldPhone";
import FieldSelect from "@/components/fields/FieldSelect";
import FieldNumber from "@/components/fields/FieldNumber";
import FieldMoney from "@/components/fields/FieldMoney";
import FieldZipcode from "@/components/fields/FieldZipcode";
import FieldLoanOfficerSelect from "@/components/fields/FieldLoanOfficerSelect";
import FieldLoanOfficerSelectId from "@/components/fields/FieldLoanOfficerSelectId";
import FieldEmail from "@/components/fields/FieldEmail";
import FieldYesNo from "@/components/fields/FieldYesNo";
import FieldYesNoTextValue from "@/components/fields/FieldYesNoTextValue";
import FieldAutocomplete from "@/components/fields/FieldAutocomplete";
import FieldPercentage from "@/components/fields/FieldPercentage";
import FieldCheckboxGroup from "@/components/fields/FieldCheckboxGroup";
import FieldSelectButtons from "@/components/fields/FieldSelectButtons";
import FieldTextarea from "@/components/fields/FieldTextarea";
import FieldRadioGroupClassic from "@/components/fields/FieldRadioGroupClassic";
import FieldRange from "@/components/fields/FieldRange";
import FieldRangeGroup from "@/components/fields/FieldRangeGroup";
import FieldReviewAndSubmit from "@/components/fields/FieldReviewAndSubmit";
import FieldSeparator from "@/components/fields/FieldSeparator";
import FieldDate from "@/components/fields/FieldDate";
import FieldAddress from "@/components/fields/FieldAddress";
import FieldState from "@/components/fields/FieldState";
import FieldSelectButtonsFullSize from "@/components/fields/FieldSelectButtonsFullSize";
import FieldSsn from "@/components/fields/FieldSsn";
import FieldCustomButtons from "@/components/fields/FieldCustomButtons";
import FieldStateLicensed from "@/components/fields/FieldStateLicensed";
import FieldAddressHistory from "@/components/fields/FieldAddressHistory";
import FieldBorrowerEmployments from "@/components/fields/FieldBorrowerEmployments";
import FieldBorrowerOtherIncome from "@/components/fields/FieldBorrowerOtherIncome";
import FieldBorrowerRealEstateOwn from "@/components/fields/FieldBorrowerRealEstateOwn";
import FieldBorrowerAssetsAccounts from "@/components/fields/FieldBorrowerAssetsAccounts";
import fieldBorrowerOtherAssets from "@/components/fields/FieldBorrowerOtherAssets";
import FieldBorrowerLiabilities from "@/components/fields/FieldBorrowerLiabilities";
import FieldBorrowerOtherLiabilities from "@/components/fields/FieldBorrowerOtherLiabilities";
import FieldDownPayment from "@/components/fields/FieldDownPayment";
import FieldFloat from "@/components/fields/FieldFloat";
import FieldAgreement from "@/components/fields/FieldAgreement.vue";

export default  {
    f_text: FieldText,
    f_date: FieldDate,
    f_text_block: FieldTextBlock,
    f_phone: FieldPhone,
    f_select: FieldSelect,
    f_number: FieldNumber,
    f_money: FieldMoney,
    f_zipcode: FieldZipcode,
    f_loan_officers_select : FieldLoanOfficerSelect,
    f_loan_officers_select_id : FieldLoanOfficerSelectId,
    f_email: FieldEmail,
    f_yes_no: FieldYesNo,
    f_autocomplete: FieldAutocomplete,
    f_percentage: FieldPercentage,
    f_checkbox_group: FieldCheckboxGroup,
    f_select_buttons: FieldSelectButtons,
    f_textarea: FieldTextarea,
    f_radio_group_classic: FieldRadioGroupClassic,
    f_radio_group_type_1: FieldRadioGroupClassic,
    f_radio_group_type_2: FieldRadioGroupClassic,
    f_radio_group_type_3: FieldRadioGroupClassic,

    f_range: FieldRange,
    f_range_group: FieldRangeGroup,
    f_review_and_submit: FieldReviewAndSubmit,
    f_separator: FieldSeparator,
    f_address: FieldAddress,
    f_state: FieldState,
    f_state_licensed: FieldStateLicensed,
    f_select_buttons_full_size: FieldSelectButtonsFullSize,
    f_ssn: FieldSsn,
    f_custom_buttons: FieldCustomButtons,
    f_address_history: FieldAddressHistory,
    f_borrower_employments: FieldBorrowerEmployments,
    f_borrower_other_income: FieldBorrowerOtherIncome,
    f_borrower_real_estate_own: FieldBorrowerRealEstateOwn,
    f_borrower_assets_accounts: FieldBorrowerAssetsAccounts,
    f_borrower_assets_other: fieldBorrowerOtherAssets,
    f_borrower_liabilities: FieldBorrowerLiabilities,
    f_borrower_other_liabilities :FieldBorrowerOtherLiabilities,
    f_yes_no_text_value :FieldYesNoTextValue,
    f_down_payment :FieldDownPayment,
    f_float :FieldFloat,
    f_agreement :FieldAgreement
};

// default = 6
export const fieldColSizes = {
    review_and_submit : '12',
    separator: '12'
};

// default all fields has a description
export const fieldsNoDescription = [
    "text_block",
    "separator",
    "agreement"
]

// default all fields has a description
export const fieldsNoAddedSpace = [
    "text_block",
    "separator",
    "address_history",
    "borrower_employments",
    "borrower_other_income",
    "borrower_real_estate_own",
    "borrower_assets_accounts",
    "borrower_assets_other",
    "borrower_liabilities",
    "borrower_other_liabilities"
]

export const fieldsWithLabelInside = [
    "checkbox_group",
    "radio_group_classic",
    "radio_group_type_1",
    "radio_group_type_2",
    "radio_group_type_3",
    "range",
    "range_group",
]
